import { notify } from 'utils/reduxUtils';

export const types = {
  ACTION_MODAL_CLOSE: 'processes/supplierTables/detailsPage/ACTION_MODAL_CLOSE',
  ACTION_MODAL_OPEN: 'processes/supplierTables/detailsPage/ACTION_MODAL_OPEN',
  DELETE_CUSTOM_TABLE_ERROR:
    'processes/supplierTables/detailsPage/DELETE_CUSTOM_TABLE_ERROR',
  DELETE_CUSTOM_TABLE_REQUEST:
    'processes/supplierTables/detailsPage/DELETE_CUSTOM_TABLE_REQUEST',
  DELETE_CUSTOM_TABLE_SUCCESS:
    'processes/supplierTables/detailsPage/DELETE_CUSTOM_TABLE_SUCCESS',
  INIT: 'processes/supplierTables/detailsPage/INIT',
  RECEIVE_TABLE_DATA: 'processes/supplierTables/detailsPage/RECEIVE_TABLE_DATA',
  RENAME_CUSTOM_TABLE_ERROR:
    'processes/supplierTables/detailsPage/RENAME_CUSTOM_TABLE_ERROR',
  RENAME_CUSTOM_TABLE_REQUEST:
    'processes/supplierTables/detailsPage/RENAME_CUSTOM_TABLE_REQUEST',
  RENAME_CUSTOM_TABLE_SUCCESS:
    'processes/supplierTables/detailsPage/RENAME_CUSTOM_TABLE_SUCCESS',
  UPDATE_CUSTOM_TABLE_ERROR:
    'processes/supplierTables/detailsPage/UPDATE_CUSTOM_TABLE_ERROR',
  UPDATE_CUSTOM_TABLE_REQUEST:
    'processes/supplierTables/detailsPage/UPDATE_CUSTOM_TABLE_REQUEST',
  UPDATE_CUSTOM_TABLE_SUCCESS:
    'processes/supplierTables/detailsPage/UPDATE_CUSTOM_TABLE_SUCCESS',
};

export const detailsPage = {
  init: ({ table }) => ({
    type: types.INIT,
    payload: { table },
  }),
  receiveTableData: ({ tableData }) => ({
    type: types.RECEIVE_TABLE_DATA,
    payload: { tableData },
  }),
};

export const actionModal = {
  open: ({ type }) => ({
    type: types.ACTION_MODAL_OPEN,
    payload: { type },
  }),
  close: () => ({
    type: types.ACTION_MODAL_CLOSE,
  }),
};

export const renameTable = {
  request: ({ name }) => ({
    type: types.RENAME_CUSTOM_TABLE_REQUEST,
    payload: { name },
  }),
  success: ({ table }) => ({
    type: types.RENAME_CUSTOM_TABLE_SUCCESS,
    payload: { table },
  }),
  error: notify(
    (error) => ({
      type: types.RENAME_CUSTOM_TABLE_ERROR,
      payload: error,
    }),
    'Failed to rename custom table',
  ),
};

export const updateTable = {
  request: (data) => ({
    type: types.UPDATE_CUSTOM_TABLE_REQUEST,
    payload: data,
  }),
  success: ({ table }) => ({
    type: types.UPDATE_CUSTOM_TABLE_SUCCESS,
    payload: { table },
  }),
  error: notify(
    (error) => ({
      type: types.UPDATE_CUSTOM_TABLE_ERROR,
      payload: error,
    }),
    'Failed to update custom table',
  ),
};

export const deleteTable = {
  request: () => ({
    type: types.DELETE_CUSTOM_TABLE_REQUEST,
  }),
  success: () => ({
    type: types.DELETE_CUSTOM_TABLE_SUCCESS,
  }),
  error: notify(
    (error) => ({
      type: types.DELETE_CUSTOM_TABLE_ERROR,
      payload: error,
    }),
    'Failed to delete custom table',
  ),
};
